import React from "react";
import i18n from 'i18next'

class Contact extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="contact">
        <div className="container text-center">
          <div className="title-block">
            <h4>{i18n.t(msg.contactDesc01)}</h4>
            <h4>{i18n.t(msg.contactDesc02)} <a href={"mailto:" + msg.contactEmail}>{msg.contactEmail}</a>{"!"}</h4>
            <a href={"mailto:" + msg.contactEmail} className="btn btn-primary" style={{ margin: "30px 0" }}>{i18n.t(msg.contactBtn)}</a>
            <div className="note" style={{ textAlign: "left" }}>
            </div>
          </div>
        </div>

        <img src="images/rightdoublearrow.png" alt="arrowGraphic" className="right-double-arrow" />
        <img src="images/leftdoublearrow.png" alt="arrowGraphic" className="left-double-arrow" />
      </section>
    );
  }
}
export default Contact;
